<template>
  <div
    class="DetailDataSets">
    <h3 class="pb-2">DataSets</h3>
    <div
      class="DetailDataSet"
      v-for="dataSet in dataSets"
      :key="dataSet.name">
      <i
        class="DetailDataSet_icon icon-domo-database">
      </i>
      <h4>
        {{ dataSet.name }}
      </h4>
      <p
        class="DetailDataSet_copy">
        {{ dataSet.desc }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailDataSets',

  props: {
    dataSets: { type: Array, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.DetailDataSet {
  position: relative;
  padding: 16px;
  padding-left: 48px;
  margin-top: 8px;
  text-align: left;
  border: $border;
  border-radius: $radius;
  background-color: $white;
}

.DetailDataSet_icon {
  display: block;
  position: absolute;
  top: 8px;
  left: 12px;
  width: 24px;
  height: 24px;
  font-size: 24px;
  opacity: 0.6;
}

.DetailDataSet_copy {
  color: $mute;
}
</style>
